import { CONSTANTS } from '../game.js';

/**
 * サウンド再生を一元管理するクラス
 */
export class SoundManager {
    /**
     * @param {Phaser.Scene} scene - シーンオブジェクト
     */
    constructor(scene) {
        this.scene = scene;
    }
    
    /**
     * ターゲット破壊時の効果音を再生
     * @param {string} evaluation - 評価（'FAIL', 'PASS', 'GOOD', 'GREAT', 'PERFECT'）
     */
    playTargetHitSound(evaluation) {
        // 評価テキストからキーを取得
        const evaluationKey = Object.entries(CONSTANTS.EVALUATION.TEXT)
            .find(([key, value]) => value === evaluation)?.[0];
        
        if (!evaluationKey) return;
        
        // 音量とピッチを評価に応じて調整
        let volume = 1.0;
        let pitch = 1.0;
        
        switch (evaluationKey) {
            case 'PERFECT':
                volume = 1.0;
                pitch = 1.0;
                break;
            case 'GREAT':
                volume = 0.9;
                pitch = 0.8;
                break;
            case 'GOOD':
                volume = 0.8;
                pitch = 1.0;
                break;
            case 'PASS':
                volume = 0.7;
                pitch = 1.2;
                break;
            case 'FAIL':
                volume = 0.6;
                pitch = 1.4;
                break;
        }
        
        // 評価に応じたサウンドファイルのキーを生成
        const soundKey = `target_hit_${evaluationKey.toLowerCase()}`;
        
        // 効果音を再生
        this.scene.sound.play(soundKey, {
            volume: volume,
            rate: pitch
        });
    }
    
    /**
     * クリティカル状態の警告音を再生
     */
    playCriticalSound() {
        this.scene.sound.play('breakSound');
    }
}
